import { get } from 'lodash'

/**
 * First matching rule gets picked as fingerprint.
 * fingerprint in form: [type, message, ...rest]
 */
export const sentryFingerprintRules = [
    {
        // AppError
        matchFunction: (data) => {
            const appError = get(data, 'extra.AppError', null)
            return appError && appError.type && appError.code
                ? ['AppError', `${appError.type}/${appError.code}`, appError.message]
                : false
        },
    },
    {
        matchRegex: /504: Gateway time-out/i,
        matchPath: 'extra.Error.message',
        fingerprint: ['Network error', 'Message: 504: Gateway time-out'],
    },
    {
        matchRegex: /^cURL error /,
        matchPath: 'extra.Error.graphQLErrors[0]',
        fingerprint: ['GraphQL error', 'Message: cURL error'],
    },
    {
        matchRegex: /Integrity constraint violation:/,
        matchPath: 'extra.Error.graphQLErrors[0]',
        fingerprint: ['GraphQL error', 'Message: SQL Integrity constraint violation'],
    },
    {
        matchRegex: /^syntax error, /,
        matchPath: 'extra.Error.graphQLErrors[0]',
        fingerprint: ['GraphQL error', 'Message: PHP syntax error'],
    },
    {
        matchRegex: /\.php on line /,
        matchPath: 'extra.Error.graphQLErrors[0]',
        fingerprint: ['GraphQL error', 'Message: Unhandled PHP exception (on line...)'],
    },
    {
        matchRegex: /^MyNettixException:/,
        matchPath: 'extra.Error.graphQLErrors[0]',
        fingerprint: ['GraphQL error', 'Message: Unhandled MyNettixException'],
    },
    {
        matchRegex: /503 Service Temporarily Unavailable/,
        matchPath: 'extra.Error.graphQLErrors[0]',
        fingerprint: ['GraphQL error', 'Message: 503 Service Temporarily Unavailable'],
    },
    {
        matchRegex: /^Network error: NetworkError when attempting to fetch resource/,
        fingerprint: ['Network error', 'Message: NetworkError when attempting to fetch resource'],
    },
    {
        matchRegex: /^Network error: JSON.parse: unexpected character at/,
        fingerprint: ['Network error', 'Message: JSON.parse: unexpected character at...'],
    },
    {
        matchRegex: /^Network error: Response not successful: Received status code 400/,
        fingerprint: ['Network error', 'Message: Response not successful: Received status code 400'],
    },
    {
        matchRegex: /^Network error: Response not successful: Received status code 404/,
        fingerprint: ['Network error', 'Message: Response not successful: Received status code 404'],
    },
    {
        matchRegex: /^Network error: Response not successful: Received status code 500/,
        fingerprint: ['Network error', 'Message: Response not successful: Received status code 500'],
    },
    {
        matchRegex: [
            /^Network error: Failed to fetch/i,
            /^Network error: Network request failed/i,
        ],
        fingerprint: ['Network error', 'Failed to fetch'],
    },
    {
        matchRegex: /^Fetch event is destroyed\./,
        fingerprint: ['Fetch event is destroyed.'],
    },
    {
        matchRegex: [
            /^Network error: cancelled/i,
            /^Network error: Kumottu/i,
            /^Network error: kumottu/i,
            /^Network error: avbruten/i,
            /^Network error: anulowane/i,
            /^Network error: vazgeçildi/i,
            /^Network error: cancelado/i,
            /^Network error: отменено/i,
            /^Network error: مُلغى/i,
            /^Network error: visszavonva/i,
        ],
        fingerprint: ['Network error', 'Cancelled'],
    },
    {
        matchRegex: /The operation couldn’t be completed\. Software caused connection abort/i,
        fingerprint: ['Network error', 'The operation couldn’t be completed. Software caused connection abort'],
    },
    {
        matchRegex: /Toimintoa ei voitu suorittaa\. Ohjelmistosta johtuva yhteyden keskeytys/i,
        fingerprint: ['Network error', 'The operation couldn’t be completed. Software caused connection abort'],
    },
    {
        matchRegex: [
            /^Network error: Verkkoyhteys katkesi/i,
            /^Network error: FetchEvent\.respondWith received an error: TypeError: Verkkoyhteys katkesi\./i,
        ],
        fingerprint: ['Network error', 'Verkkoyhteys katkesi'],
    },
    {
        matchRegex: /^ServerParseError$/,
        matchPath: 'extra.Error.networkError',
        fingerprint: ['Network error', 'Message: ServerParseError'],
    },
    {
        matchRegex: /^Page not found: (http|https):\/\/webcache.googleusercontent.com/,
        fingerprint: ['Page not found', 'Message: webcache.googleusercontent.com'],
    },
    {
        matchRegex: /^Page not found:/,
        fingerprint: ['Page not found'],
    },
    {
        matchRegex: /moz-extension:/i,
        fingerprint: ['Extension error', 'moz-extension'],
    },
    {
        matchRegex: [
            /zendesk\.com/i,
            /zdassets\.com/i,
        ],
        fingerprint: ['Zendesk error', 'Contains zendesk.com or zdassets.com'],
    },
    {
        matchRegex: 'react-i18next key "(.*)" not found',
        fingerprint: ['react-i18next', 'Missing key'],
    },
]
